import { useState, useEffect, FC } from "react"
import {
  List,
  ListItem,
  Checkbox,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Button
} from "@mui/material"

import { interests as interestOptions } from "../../../consts"
import { useProfileSettingsEditor } from "../hooks/useProfileSettings"
import { IOSSwitch } from "../iosswitch/IOSSwitch"

import {
  interestsList,
  interestsListItem,
  interestsListButton,
  interestsListAllButton,
  interestsSaveButton
} from "./interestsSettingsStyle"
import s from "./styles.module.scss"

const InterestsSettings: FC = () => {
  const [selectedInterestIds, setSelectedInterestIds] = useState<Set<number>>(
    new Set(),
  )

  const { updateProfile, currentUser } = useProfileSettingsEditor()

  useEffect(() => {
    if (currentUser) {
      setSelectedInterestIds(
        new Set(currentUser.interesting_event_type.map((item) => item.id)),
      )
    }
  }, [currentUser])

  const handleToggleAll = (): void => {
    setSelectedInterestIds(
      (prev) =>
        new Set(
          prev.size === interestOptions.length
            ? []
            : interestOptions.map((item) => item.id),
        ),
    )
  }

  const handleToggleInterest = (id: number): void => {
    setSelectedInterestIds(
      (prev) =>
        new Set(
          prev.has(id) ? [...prev].filter((v) => v !== id) : [...prev, id],
        ),
    )
  }

  const handleSave = (): void => {
    updateProfile({
      interesting_event_type: Array.from(selectedInterestIds),
    })
  }

  const renderInterestsList = (): JSX.Element[] => {
    return interestOptions.map((option) => (
      <ListItem key={option.id} sx={interestsListItem} disablePadding>
        <ListItemButton
          sx={interestsListButton}
          role={undefined}
          onClick={() => handleToggleInterest(option.id)}
          dense
          disableGutters
        >
          <option.icon />
          <ListItemText
            id={option.id.toString()}
            primary={option.text}
            disableTypography
            sx={{
              margin: 0,
              fontFamily: "Roboto",
              fontWeight: 500,
              fontSize: "14px",
              span: {
                fontWeight: 500,
              },
            }}
          />
          <ListItemIcon>
            <Checkbox
              sx={{
                margin: 0,
                padding: 0,
                right: 0,
                color: "var(--Schemes-On-Surface)",
                "&.Mui-checked": {
                  color: "var(--Schemes-Primary)",
                },
              }}
              edge="start"
              checked={selectedInterestIds.has(option.id)}
              tabIndex={-1}
              disableRipple
              inputProps={{ "aria-labelledby": option.text }}
            />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
    ))
  }

  return (
    <div className={s.interests_container}>
      <List sx={interestsList} disablePadding>
        <ListItem sx={interestsListItem} disablePadding>
          <ListItemButton
            sx={interestsListAllButton}
            role={undefined}
            onClick={handleToggleAll}
            dense
            disableGutters
          >
            <ListItemText
              id="select-all"
              primary="Все"
              disableTypography
              sx={{
                margin: 0,
                fontFamily: "Roboto",
                fontWeight: 500,
                fontSize: "14px",
                span: {
                  fontWeight: 500,
                },
              }}
            />
            <ListItemIcon>
              <IOSSwitch
                sx={{ m: 0 }}
                checked={selectedInterestIds.size === interestOptions.length}
                inputProps={{ "aria-labelledby": "select-all" }} />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
        {renderInterestsList()}
      </List>

      <Button
        variant="text"
        type="submit"
        aria-label="save changes"
        sx={interestsSaveButton}
        onClick={handleSave}>
          Применить
      </Button>
    </div>
  )
}
export default InterestsSettings
